import { useState } from 'react';

import { useAnalytics } from '@r-client/shared/data/analytics';
import { Button, IButtonProps, Link, Text } from '@r-client/shared/ui/core';
import { Dropdown } from '@r-client/shared/ui/dropdown';
import { Forward, SvgIconLight } from '@r-client/shared/ui/icons';
import { BasicMenu, BasicMenuItem } from '@r-client/shared/ui/menu';

import { TCalendarEvent } from '../../utils';
import { getShareCollection } from '../../utils/get-share-url';
import { ShareIcon } from './share-icon';

export interface IShareButtonProps extends IButtonProps {
  event: TCalendarEvent;
}

export const ShareButton = ({ event, ...restProps }: IShareButtonProps) => {
  const analytics = useAnalytics();
  const [visible, setVisible] = useState(false);
  const closeDropdown = (calendarName: string) => {
    analytics.track({
      name: 'event_share_button_clicked',
      params: { calendar_name: calendarName },
    });
    setVisible(false);
  };

  return (
    <Dropdown
      arrow
      trigger="hover"
      visible={visible}
      onVisibleChange={setVisible}
      content={
        <BasicMenu>
          {getShareCollection(event).map((calendar) => {
            return (
              <BasicMenuItem
                key={calendar.type}
                onClick={() => closeDropdown(calendar.displayName)}
              >
                <Link
                  target="_blank"
                  rel="nofollow noopener"
                  variant={Link.variants.unstyled}
                  href={calendar.url}
                >
                  <div>
                    <Text as="span" m="0 1brm 0 0" color="blue">
                      <ShareIcon type={calendar.type} />
                    </Text>
                    {calendar.displayName}
                  </div>
                </Link>
              </BasicMenuItem>
            );
          })}
        </BasicMenu>
      }
    >
      <Button {...restProps}>
        <SvgIconLight icon={Forward} />
      </Button>
    </Dropdown>
  );
};
